import _ from 'lodash'

function applyRoleFilter(parsedFilters, currentAccountId) {
  if (!parsedFilters.role || !currentAccountId) return

  if (parsedFilters.role === 'owner') {
    parsedFilters.owner = currentAccountId
  }

  if (parsedFilters.role === 'coach') {
    parsedFilters.coach = currentAccountId
  }

  if (parsedFilters.role === 'collaborators') {
    parsedFilters.collaborators = [currentAccountId]
  }

  delete parsedFilters.role
}

function applyValidationFilter(parsedFilters) {
  if (!parsedFilters.validation) return

  if (parsedFilters.validation === 'hasNotImplementationValidation') {
    parsedFilters.hasImplementationValidation = false
    parsedFilters.hasFinancialValidation = false
    delete parsedFilters.validation
    return
  }

  parsedFilters[parsedFilters.validation] = true

  if (parsedFilters.hasImplementationValidation) {
    parsedFilters.hasFinancialValidation = false
  }

  delete parsedFilters.validation
}

function applyConditionFilter(parsedFilters) {
  if (_.isEmpty(parsedFilters.condition)) return

  parsedFilters.condition.forEach(condition => {
    if (condition === 'isNotRevFromFinding') {
      parsedFilters.isRevFromFinding = false
      return
    }

    parsedFilters[condition] = true
  })

  delete parsedFilters.condition
}

function applyRoutineFilters(parsedFilters, currentAccountId) {
  if (
    !_.isNil(parsedFilters.routineType) &&
    !_.isEmpty(parsedFilters.routineType)
  ) {
    parsedFilters.type = parsedFilters.routineType
  }

  delete parsedFilters.routineType

  if (parsedFilters.routineDefinitionsPresetFilter === 'executableByMe') {
    parsedFilters.isExecutableByMe = true
  }

  if (
    parsedFilters.routineDefinitionsPresetFilter === 'createdByMe' &&
    currentAccountId
  ) {
    parsedFilters.createdBy = currentAccountId
  }

  if (
    parsedFilters.routineDefinitionsPresetFilter === 'collaborator' &&
    currentAccountId
  ) {
    parsedFilters.collaborators = [currentAccountId]
  }

  delete parsedFilters.routineDefinitionsPresetFilter
}

function removeEmptyFilters(parsedFilters) {
  return _.pickBy(parsedFilters, value => {
    if (_.isArray(value)) return !_.isEmpty(value)
    if (_.isPlainObject(value)) return !_.isEmpty(value)
    return !_.isNil(value) && value !== ''
  })
}

export default function serializeExploreFilters({
  filters = {},
  currentAccountId = null,
}) {
  const parsedFilters = { ...filters }

  applyRoleFilter(parsedFilters, currentAccountId)
  applyValidationFilter(parsedFilters)
  applyConditionFilter(parsedFilters)
  applyRoutineFilters(parsedFilters, currentAccountId)

  return removeEmptyFilters(parsedFilters)
}
